import { Controller } from "@hotwired/stimulus"

// Choosing an option only chooses it; the button says what saving will do.
// A decision other than validating needs a reason the evaluator will read:
// the field says so, takes the cursor, and the browser asks for it before
// the form leaves (docs/icomos.md, Revisió).
export default class extends Controller {
  static targets = ["reason", "requirement", "submit"]
  static values = { labels: Object }

  connect() { this.sync() }

  choose() {
    this.sync()
    if (this.reasonTarget.required) this.reasonTarget.focus()
  }

  sync() {
    const decision = this.element.querySelector("input[name='review[decision]']:checked")?.value
    this.reasonTarget.required = Boolean(decision) && decision !== "validated"
    this.requirementTarget.hidden = !this.reasonTarget.required
    if (decision && this.labelsValue[decision]) this.submitTarget.value = this.labelsValue[decision]
  }
}
